module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/winStoreLogo.39287f5f.svg";